// https://learn.microsoft.com/en-us/azure/cognitive-services/speech-service/language-support?tabs=stt

const languages = [
  {
    language: 'Afrikaans (South Africa)',
    code: 'af-ZA',
  },
  {
    language: 'Amharic (Ethiopia)',
    code: 'am-ET',
  },
  {
    language: 'Arabic (United Arab Emirates)',
    code: 'ar-AE',
  },
  {
    language: 'Arabic (Bahrain)',
    code: 'ar-BH',
  },
  {
    language: 'Arabic (Algeria)',
    code: 'ar-DZ',
  },
  {
    language: 'Arabic (Egypt)',
    code: 'ar-EG',
  },
  {
    language: 'Arabic (Israel)',
    code: 'ar-IL',
  },
  {
    language: 'Arabic (Iraq)',
    code: 'ar-IQ',
  },
  {
    language: 'Arabic (Jordan)',
    code: 'ar-JO',
  },
  {
    language: 'Arabic (Kuwait)',
    code: 'ar-KW',
  },
  {
    language: 'Arabic (Lebanon)',
    code: 'ar-LB',
  },
  {
    language: 'Arabic (Libya)',
    code: 'ar-LY',
  },
  {
    language: 'Arabic (Morocco)',
    code: 'ar-MA',
  },
  {
    language: 'Arabic (Oman)',
    code: 'ar-OM',
  },
  {
    language: 'Arabic (Palestinian Territories)',
    code: 'ar-PS',
  },
  {
    language: 'Arabic (Qatar)',
    code: 'ar-QA',
  },
  {
    language: 'Arabic (Saudi Arabia)',
    code: 'ar-SA',
  },
  {
    language: 'Arabic (Syria)',
    code: 'ar-SY',
  },
  {
    language: 'Arabic (Tunisia)',
    code: 'ar-TN',
  },
  {
    language: 'Arabic (Yemen)',
    code: 'ar-YE',
  },
  {
    language: 'Azerbaijani (Latin, Azerbaijan)',
    code: 'az-AZ',
  },
  {
    language: 'Bulgarian (Bulgaria)',
    code: 'bg-BG',
  },
  {
    language: 'Bengali (India)',
    code: 'bn-IN',
  },
  {
    language: 'Bosnian (Bosnia and Herzegovina)',
    code: 'bs-BA',
  },
  {
    language: 'Catalan (Spain)',
    code: 'ca-ES',
  },
  {
    language: 'Czech (Czechia)',
    code: 'cs-CZ',
  },
  {
    language: 'Welsh (United Kingdom)',
    code: 'cy-GB',
  },
  {
    language: 'Danish (Denmark)',
    code: 'da-DK',
  },
  {
    language: 'German (Austria)',
    code: 'de-AT',
  },
  {
    language: 'German (Switzerland)',
    code: 'de-CH',
  },
  {
    language: 'German (Germany)',
    code: 'de-DE',
  },
  {
    language: 'Greek (Greece)',
    code: 'el-GR',
  },
  {
    language: 'English (Australia)',
    code: 'en-AU',
  },
  {
    language: 'English (Canada)',
    code: 'en-CA',
  },
  {
    language: 'English (United Kingdom)',
    code: 'en-GB',
  },
  {
    language: 'English (Ghana)',
    code: 'en-GH',
  },
  {
    language: 'English (Hong Kong SAR)',
    code: 'en-HK',
  },
  {
    language: 'English (Ireland)',
    code: 'en-IE',
  },
  {
    language: 'English (India)',
    code: 'en-IN',
  },
  {
    language: 'English (Kenya)',
    code: 'en-KE',
  },
  {
    language: 'English (Nigeria)',
    code: 'en-NG',
  },
  {
    language: 'English (New Zealand)',
    code: 'en-NZ',
  },
  {
    language: 'English (Philippines)',
    code: 'en-PH',
  },
  {
    language: 'English (Singapore)',
    code: 'en-SG',
  },
  {
    language: 'English (Tanzania)',
    code: 'en-TZ',
  },
  {
    language: 'English (United States)',
    code: 'en-US',
  },
  {
    language: 'English (South Africa)',
    code: 'en-ZA',
  },
  {
    language: 'Spanish (Argentina)',
    code: 'es-AR',
  },
  {
    language: 'Spanish (Bolivia)',
    code: 'es-BO',
  },
  {
    language: 'Spanish (Chile)',
    code: 'es-CL',
  },
  {
    language: 'Spanish (Colombia)',
    code: 'es-CO',
  },
  {
    language: 'Spanish (Costa Rica)',
    code: 'es-CR',
  },
  {
    language: 'Spanish (Cuba)',
    code: 'es-CU',
  },
  {
    language: 'Spanish (Dominican Republic)',
    code: 'es-DO',
  },
  {
    language: 'Spanish (Ecuador)',
    code: 'es-EC',
  },
  {
    language: 'Spanish (Spain)',
    code: 'es-ES',
  },
  {
    language: 'Spanish (Equatorial Guinea)',
    code: 'es-GQ',
  },
  {
    language: 'Spanish (Guatemala)',
    code: 'es-GT',
  },
  {
    language: 'Spanish (Honduras)',
    code: 'es-HN',
  },
  {
    language: 'Spanish (Mexico)',
    code: 'es-MX',
  },
  {
    language: 'Spanish (Nicaragua)',
    code: 'es-NI',
  },
  {
    language: 'Spanish (Panama)',
    code: 'es-PA',
  },
  {
    language: 'Spanish (Peru)',
    code: 'es-PE',
  },
  {
    language: 'Spanish (Puerto Rico)',
    code: 'es-PR',
  },
  {
    language: 'Spanish (Paraguay)',
    code: 'es-PY',
  },
  {
    language: 'Spanish (El Salvador)',
    code: 'es-SV',
  },
  {
    language: 'Spanish (United States)',
    code: 'es-US',
  },
  {
    language: 'Spanish (Uruguay)',
    code: 'es-UY',
  },
  {
    language: 'Spanish (Venezuela)',
    code: 'es-VE',
  },
  {
    language: 'Estonian (Estonia)',
    code: 'et-EE',
  },
  {
    language: 'Basque',
    code: 'eu-ES',
  },
  {
    language: 'Persian (Iran)',
    code: 'fa-IR',
  },
  {
    language: 'Finnish (Finland)',
    code: 'fi-FI',
  },
  {
    language: 'Filipino (Philippines)',
    code: 'fil-PH',
  },
  {
    language: 'French (Belgium)',
    code: 'fr-BE',
  },
  {
    language: 'French (Canada)',
    code: 'fr-CA',
  },
  {
    language: 'French (Switzerland)',
    code: 'fr-CH',
  },
  {
    language: 'French (France)',
    code: 'fr-FR',
  },
  {
    language: 'Irish (Ireland)',
    code: 'ga-IE',
  },
  {
    language: 'Galician',
    code: 'gl-ES',
  },
  {
    language: 'Gujarati (India)',
    code: 'gu-IN',
  },
  {
    language: 'Hebrew (Israel)',
    code: 'he-IL',
  },
  {
    language: 'Hindi (India)',
    code: 'hi-IN',
  },
  {
    language: 'Croatian (Croatia)',
    code: 'hr-HR',
  },
  {
    language: 'Hungarian (Hungary)',
    code: 'hu-HU',
  },
  {
    language: 'Armenian (Armenia)',
    code: 'hy-AM',
  },
  {
    language: 'Indonesian (Indonesia)',
    code: 'id-ID',
  },
  {
    language: 'Icelandic (Iceland)',
    code: 'is-IS',
  },
  {
    language: 'Italian (Switzerland)',
    code: 'it-CH',
  },
  {
    language: 'Italian (Italy)',
    code: 'it-IT',
  },
  {
    language: 'Japanese (Japan)',
    code: 'ja-JP',
  },
  {
    language: 'Javanese (Latin, Indonesia)',
    code: 'jv-ID',
  },
  {
    language: 'Georgian (Georgia)',
    code: 'ka-GE',
  },
  {
    language: 'Kazakh (Kazakhstan)',
    code: 'kk-KZ',
  },
  {
    language: 'Khmer (Cambodia)',
    code: 'km-KH',
  },
  {
    language: 'Kannada (India)',
    code: 'kn-IN',
  },
  {
    language: 'Korean (Korea)',
    code: 'ko-KR',
  },
  {
    language: 'Lao (Laos)',
    code: 'lo-LA',
  },
  {
    language: 'Lithuanian (Lithuania)',
    code: 'lt-LT',
  },
  {
    language: 'Latvian (Latvia)',
    code: 'lv-LV',
  },
  {
    language: 'Macedonian (North Macedonia)',
    code: 'mk-MK',
  },
  {
    language: 'Malayalam (India)',
    code: 'ml-IN',
  },
  {
    language: 'Mongolian (Mongolia)',
    code: 'mn-MN',
  },
  {
    language: 'Marathi (India)',
    code: 'mr-IN',
  },
  {
    language: 'Malay (Malaysia)',
    code: 'ms-MY',
  },
  {
    language: 'Maltese (Malta)',
    code: 'mt-MT',
  },
  {
    language: 'Burmese (Myanmar)',
    code: 'my-MM',
  },
  {
    language: 'Norwegian Bokm\u00e5l (Norway)',
    code: 'nb-NO',
  },
  {
    language: 'Nepali (Nepal)',
    code: 'ne-NP',
  },
  {
    language: 'Dutch (Belgium)',
    code: 'nl-BE',
  },
  {
    language: 'Dutch (Netherlands)',
    code: 'nl-NL',
  },
  {
    language: 'Polish (Poland)',
    code: 'pl-PL',
  },
  {
    language: 'Pashto (Afghanistan)',
    code: 'ps-AF',
  },
  {
    language: 'Portuguese (Brazil)',
    code: 'pt-BR',
  },
  {
    language: 'Portuguese (Portugal)',
    code: 'pt-PT',
  },
  {
    language: 'Romanian (Romania)',
    code: 'ro-RO',
  },
  {
    language: 'Russian (Russia)',
    code: 'ru-RU',
  },
  {
    language: 'Sinhala (Sri Lanka)',
    code: 'si-LK',
  },
  {
    language: 'Slovak (Slovakia)',
    code: 'sk-SK',
  },
  {
    language: 'Slovenian (Slovenia)',
    code: 'sl-SI',
  },
  {
    language: 'Somali (Somalia)',
    code: 'so-SO',
  },
  {
    language: 'Albanian (Albania)',
    code: 'sq-AL',
  },
  {
    language: 'Serbian (Cyrillic, Serbia)',
    code: 'sr-RS',
  },
  {
    language: 'Swedish (Sweden)',
    code: 'sv-SE',
  },
  {
    language: 'Swahili (Kenya)',
    code: 'sw-KE',
  },
  {
    language: 'Swahili (Tanzania)',
    code: 'sw-TZ',
  },
  {
    language: 'Tamil (India)',
    code: 'ta-IN',
  },
  {
    language: 'Telugu (India)',
    code: 'te-IN',
  },
  {
    language: 'Thai (Thailand)',
    code: 'th-TH',
  },
  {
    language: 'Turkish (Turkey)',
    code: 'tr-TR',
  },
  {
    language: 'Ukrainian (Ukraine)',
    code: 'uk-UA',
  },
  {
    language: 'Uzbek (Latin, Uzbekistan)',
    code: 'uz-UZ',
  },
  {
    language: 'Vietnamese (Vietnam)',
    code: 'vi-VN',
  },
  {
    language: 'Chinese (Wu, Simplified)',
    code: 'wuu-CN',
  },
  {
    language: 'Chinese (Cantonese, Simplified)',
    code: 'yue-CN',
  },
  {
    language: 'Chinese (Mandarin, Simplified)',
    code: 'zh-CN',
  },
  {
    language: 'Chinese (Southwestern Mandarin, Simplified)',
    code: 'zh-CN-sichuan',
  },
  {
    language: 'Chinese (Cantonese, Traditional)',
    code: 'zh-HK',
  },
  {
    language: 'Chinese (Taiwanese Mandarin, Traditional)',
    code: 'zh-TW',
  },
  {
    language: 'Zulu (South Africa)',
    code: 'zu-ZA',
  },
];

export default languages;
